import { PageHeaderComponent } from '@aston/foundation/components';
import { RouterLink, RouterOutlet } from '@angular/router';
import { TranslateDirective } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { LayoutBaseComponent } from '../../../shared-module/layouts/layout-base/layout-base.component';
import { TopBarComponent } from '../../../shared-module/components/top-bar/top-bar.component';
import { MenuLinksComponent } from '../../components/menu-links/menu-links.component';
import { ActiveRouteService } from '../../../shared-module/services';
import * as RoutesDefinitions from '../../../routes-definitions';

@Component({
	selector: 'federations-menu-layout',
	templateUrl: './federations-menu-layout.component.html',
	imports: [LayoutBaseComponent, MenuLinksComponent, TopBarComponent, PageHeaderComponent, TranslateDirective, RouterLink, RouterOutlet, AsyncPipe]
})
export class FederationsMenuLayoutComponent extends LayoutBaseComponent {
	private activeRouteService = inject(ActiveRouteService);
	protected store = inject(Store);

	federationsRoutePath = RoutesDefinitions.getFederationsFullPath();

	tenantTitle$ = this.activeRouteService.tenantTitle$;
}
